import GameScene from './game/a.scenes/GameScene/GameScene'
// import LandingScene from './game/a.scenes/LandingScene/LandingScene'
import Scenes from './game/b.providers/ScenesProvider/Scenes'
// import DebugScene from './game/a.scenes/DebugScene/DebugScene'
// import NebulaScene from './game/a.scenes/NebulaScene/NebulaScene'
// import VFXScene from './game/a.scenes/VFXScene/VFXScene'
// import MoveScene from './game/a.scenes/MoveScene/MoveScene'
// import LevelTestScene from './game/a.scenes/LevelTestScene/LevelTestScene'
// import TeamSelectionScene from './game/a.scenes/TeamSelectionScene/TeamSelectionScene'
import SplashScene from './game/a.scenes/SplashScene/SplashScene'

const Game = () => {
  return (
    <Scenes>
      <SplashScene />
      <GameScene />
      {/* <LevelTestScene />
      <LandingScene />
      <TeamSelectionScene />
      <DebugScene />
      <MoveScene />
      <VFXScene />
      <NebulaScene /> */}
    </Scenes>
  )
}

export default Game
